import React from 'react';
import PropTypes from 'prop-types';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import ActionInProgress from './ActionInProgress';
import ActionSelection from './ActionSelection';

import './styles.scss';

const contactActions = {
    call: 'Calling...',
    sms: 'Opening Text Message...',
};

class InquiryContact extends React.Component {
    static propTypes = {
        intentionType: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        phone: PropTypes.string.isRequired,
        onExecuteAction: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.handleResetAction = this.handleResetAction.bind(this);
        this.handleSetAction = this.handleSetAction.bind(this);

        this.didActionOnUpdate = false;
        this.state = {
            inProgress: false,
        };
    }

    componentDidUpdate() {
        const { isMobile, intentionType } = this.props;

        if (isMobile && !this.didActionOnUpdate) {
            this.didActionOnUpdate = true;
            this.setAction(intentionType, false);
        }
    }

    handleResetAction() {
        this.resetAction();
    }

    handleSetAction(intentionType) {
        this.setAction(intentionType);
    }

    setAction(intentionType, sendIntention = true) {
        const { onExecuteAction } = this.props;
        if (!this.state.inProgress) {
            this.setState({
                inProgress: true,
            });
        }
        onExecuteAction(intentionType, sendIntention);
    }

    resetAction() {
        this.setState({
            inProgress: false,
        });
    }

    render() {
        const { intentionType, name, phone } = this.props;

        return (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <Text className="stacked-sm">Contact</Text>
                        <Text type="h1">{name}</Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text type="h3" className="stacked-md">
                            {phone}
                        </Text>
                    </Col>
                    <Col>
                        {this.state.inProgress ? (
                            <ActionInProgress onResetAction={this.handleResetAction}>
                                {contactActions[intentionType]}
                            </ActionInProgress>
                        ) : (
                            <ActionSelection onSelectAction={this.handleSetAction} />
                        )}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default InquiryContact;
